export const datesettings = {
    bigBanner: false,
    timePicker: false,
    format: 'dd-MM-yyyy',
    defaultOpen: false,
    closeOnSelect: true
};

export const datetimesettings = {
    bigBanner: true,
    timePicker: true,
    format: 'dd-MM-yyyy hh:mm a',
    defaultOpen: false,
    closeOnSelect: true
};

export function isDateRangeValid(date1: Date, time1: number, date2: Date, time2: number): boolean {
    const fromDate = new Date(date1);
    fromDate.setHours(0, (time1 * 60), 0, 0);
    const toDate = new Date(date2);
    toDate.setHours(0, (time2 * 60), 0, 0);
    console.log(`From: ${fromDate} to ${toDate}`);
    return toDate.getTime() > fromDate.getTime();
}

export const deepCopy = (obj) => {
    let copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || 'object' !== typeof obj) {
        return obj;
    }

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (let i = 0, len = obj.length; i < len; i ++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (const attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                copy[attr] = deepCopy(obj[attr]);
            }
        }
        return copy;
    }

    throw new Error('Unable to copy obj! Its type isn\'t supported.');
};
